import React, { useState, useEffect } from "react";
import { Typography, Container, Card } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import HarvestIcon from "../../assets/Icon/HarvestIcon.png";
import CustomCard from "../../components/Famer/GenericCard";
export const StyledCard = styled(Card)`
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
`;

export default function Harvests() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/farmer/harvests/`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };
  const handleAddHarvest = () => {
    navigate("/farmer/create-harvest");
  };
  const handleView = (harvestId) => {
    navigate(`/farmer/harvest/${harvestId}`);
  };
  const handleAddSale = (harvestId) => {
    navigate(`/farmer/harvest-sales-add/${harvestId}`);
  };
  return (
    <>
      <CustomAppBar title="Harvests" />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: data.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // alignItems: "center", // Center items horizontally
          }}
        >
          {data.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("Harvest")}
            </Typography>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {data.map((harvest) => (
              <CustomCard
                key={harvest.id}
                id={harvest.id}
                t={t}
                data={{
                  "Crop Name": harvest.crop.crop_type,

                  "Harvest Date": harvest.harvest_date,
                  "Quantity (kg)": harvest.quantity,
                }}
                file={harvest.picture}
                handlePrimaryButton={handleView}
                secondaryButtonLabel={t("Add Sale")}
                handleSecondaryButton={handleAddSale}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {data.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={HarvestIcon}
                  alt="My Crops Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleAddHarvest}>
              {t("Add Harvest")}
            </CustomButton>
            {data.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, textAlign: "center" }}
              >
                {t("Your harvests will be displayed here once you add them..")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
